import * as React from 'react';
import { useSelector } from 'react-redux';
import { Track } from 'livekit-client';
import {
  TrackReferenceOrPlaceholder,
  getTrackReferenceId,
} from '@livekit/components-core';
import { AudioTrack, useTracks } from '@livekit/components-react';
import { selectLiveOutputPreviewVolume } from '../../redux/slices/room';

export const getConferenceTrackVolume = (
  trackReference: TrackReferenceOrPlaceholder,
  liveOutputPreviewVolume: number,
) =>
  trackReference.source === Track.Source.ScreenShareAudio &&
  trackReference.participant.identity
    .toLowerCase()
    .startsWith('liveoutputpreview')
    ? liveOutputPreviewVolume
    : undefined;

export const ConferenceAudioRenderer = () => {
  const liveOutputPreviewVolume = useSelector(selectLiveOutputPreviewVolume);
  const tracks = useTracks(
    [
      Track.Source.Microphone,
      Track.Source.ScreenShareAudio,
      Track.Source.Unknown,
    ],
    {
      updateOnlyOn: [],
      onlySubscribed: true,
    },
  ).filter(
    ref =>
      !ref.participant.isLocal && ref.publication.kind === Track.Kind.Audio,
  );

  return (
    <div style={{ display: 'none' }}>
      {tracks.map(trackRef => (
        <AudioTrack
          key={getTrackReferenceId(trackRef)}
          trackRef={trackRef}
          volume={getConferenceTrackVolume(trackRef, liveOutputPreviewVolume)}
        />
      ))}
    </div>
  );
};
